import { TypographyColor } from 'melp-design/components';
import { ShopItemStatus } from 'store/shop';

export const COLOR_BY_STATUS: Record<ShopItemStatus, TypographyColor> = {
  active: 'success',
  inactive: 'textSecondary',
  archived: 'textSecondary',
};
